const prides = [
  { name: "lgbt", day: "6-28" }, // LGBT - Stonewall Riots Anniversary 28 June
  { name: "trans", day: "3-31" }, // Trans Day of Visibility 31 March
  { name: "non-binary", day: "7-14" }, // Non-Binary People's Day 14 July
  { name: "agender", day: "5-19" }, // Agender Pride Day - 19 May
  // Intersex Awareness Day - 26 October
  // Pansexual & Panromantic Awareness Day - 24 May
  // tk 👇 maybe start and end days for:
  // Asexual Awareness Week - Last full week in October
  // etc.. ask for suggestions
  { name: "juneteenth", day: "6-19" }, // Freedom Day, Jubilee Day, Liberation Day, Emancipation Day
  { name: "women", day: "3-8" },
];

export function prideClass() {
  const now = new Date();
  const day = `${now.getMonth() + 1}-${now.getDate()}`;
  let pride = prides.find(a => a.day === day);
  // querystring for debugging
  try {
    const u = new URL(location);
    if (u.searchParams.has("pride")) {
      pride = prides.find(a => a.name === u.searchParams.get("pride"));
    }
  } catch (e) {
    console.warn("huh", e);
  }
  if (pride) {
    return { pride: true, [pride.name]: true };
  }
}
